// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Do not edit directly
 * Generated on Tue, 19 Dec 2023 15:27:21 GMT
 */

:root {
  --spacing-xl: 55px;
  --spacing-lg: 44px;
  --spacing-md: 33px;
  --spacing-sm: 22px;
  --spacing-xs: 11px;
  --color-purple-light-1: #aa8dfc;
  --color-purple-light-2: #9370f9;
  --color-purple-light-3: #815af7;
  --color-purple-primary: #6f42f3;
  --color-purple-dark-1: #6439e4;
  --color-purple-dark-2: #5a30d7;
  --color-purple-dark-3: #4f28c0;
  --color-violet-light-1: #ed79d5;
  --color-violet-light-2: #e55ecb;
  --color-violet-light-3: #de45c6;
  --color-violet-primary: #d42fc2;
  --color-violet-dark-1: #cc1dc1;
  --color-violet-dark-2: #c00fc4;
  --color-violet-dark-3: #ac06bc;
  --color-yellow-light-1: #ffe18e;
  --color-yellow-light-2: #fedb7c;
  --color-yellow-light-3: #fdd66b;
  --color-yellow-primary: #faca48;
  --color-yellow-dark-1: #f5bf2a;
  --color-yellow-dark-2: #edb312;
  --color-yellow-dark-3: #e4a700;
  --color-orange-light-1: #ffb154;
  --color-orange-light-2: #fd9d39;
  --color-orange-light-3: #f98925;
  --color-orange-primary: #f27716;
  --color-orange-dark-1: #ea670e;
  --color-orange-dark-2: #de5809;
  --color-orange-dark-3: #cf4a06;
  --color-teal-light-1: #66d9e8;
  --color-teal-light-2: #3bc9db;
  --color-teal-light-3: #22b8cf;
  --color-teal-primary: #15aabf;
  --color-teal-dark-1: #1098ad;
  --color-teal-dark-2: #0c8599;
  --color-teal-dark-3: #0b7285;
  --color-lime-light-1: #e9fac8;
  --color-lime-light-2: #d8f5a2;
  --color-lime-light-3: #c0eb75;
  --color-lime-primary: #a9e34b;
  --color-lime-dark-1: #94d82d;
  --color-lime-dark-2: #82c91e;
  --color-lime-dark-3: #74b816;
  --color-green-light-1: #60d275;
  --color-green-light-2: #40c35d;
  --color-green-light-3: #28b44e;
  --color-green-primary: #16a544;
  --color-green-dark-1: #0b963f;
  --color-green-dark-2: #04873b;
  --color-green-dark-3: #007838;
  --color-red-light-1: #ff6f6f;
  --color-red-light-2: #f85454;
  --color-red-light-3: #ee3e3e;
  --color-red-primary: #e02c2c;
  --color-red-dark-1: #d32020;
  --color-red-dark-2: #c21515;
  --color-red-dark-3: #b10d0d;
  --color-blue-light-1: #54a9fe;
  --color-blue-light-2: #3b97f3;
  --color-blue-light-3: #2a88e6;
  --color-blue-primary: #1976d2;
  --color-blue-dark-0: #000000;
  --color-blue-dark-1: #1265c2;
  --color-blue-dark-2: #0a59b2;
  --color-blue-dark-3: #004ba0;
  --color-white: #ffffff;
  --color-lightui-surface-1: #fbfbfb;
  --color-lightui-surface-2: #f4f4f4;
  --color-lightui-surface-3: #efefef;
  --color-lightui-surface-4: #e4e4e4;
  --color-lightui-accent-1: #d8d8d8;
  --color-lightui-accent-2: #c3c3c3;
  --color-darkui-accent-3: #a6a6a6;
  --color-darkui-accent-2: #6c6c6c;
  --color-darkui-accent-1: #515151;
  --color-darkui-surface-4: #3b3b3b;
  --color-darkui-surface-3: #252525;
  --color-darkui-surface-2: #1d1d1d;
  --color-darkui-surface-1: #101010;
  --color-black: #000000;
  --color-blue-light-1-30: rgba(84, 169, 254, 0.3); /* #54a9fe with 30% opacity */
  --color-blue-light-1-50: rgba(84, 169, 254, 0.5); /* #54a9fe with 50% opacity */
  --color-white-85: rgba(255, 255, 255, 0.85); /* #ffffff with 85% opacity */
  --color-white-25: rgba(255, 255, 255, 0.25); /* #ffffff with 25% opacity */
  --color-lightui-surface-1-90: rgba(251, 251, 251, 0.9); /* #fbfbfb with 90% opacity */
  --color-black-50: rgba(0, 0, 0, 0.5); /* #000000 with 50% opacity */
  --color-black-10: rgba(0, 0, 0, 0.1); /* #000000 with 10% opacity */
  --color-darkui-accent-2-50: rgba(108, 108, 108, 0.5); /* #6c6c6c with 50% opacity */
  --color-darkui-accent-2-80: rgba(108, 108, 108, 0.8); /* #6c6c6c with 80% opacity */
  --color-712: #ff5d7c;
  --color-711: #d527c0;
  --color-710: #ddc909;
  --color-709: #6f42f3;
  --color-708: #815af7;
  --color-707: #a606bc;
  --color-706: #df88cd;
  --color-705: #cf18c4;
  --color-704: #de33cb;
  --color-703: #9c00ff;
  --color-702: #6439e4;
  --color-701: #cf23b8;
  --color-700: #632d5c;
  --color-617: #ff9735;
  --color-616: #f27019;
  --color-615: #feaf5a;
  --color-614: #ff841e;
  --color-613: #fed7a5;
  --color-612: #ed7e00;
  --color-611: #ff9e0d;
  --color-610: #ffbc50;
  --color-609: #ffbc50;
  --color-608: #ff9406;
  --color-607: #ffa910;
  --color-606: #ffdd9e;
  --color-605: #ed7e00;
  --color-604: #e9ae00;
  --color-602: #cc6300;
  --color-601: #ff9e0d;
  --color-600: #fc9e31;
  --color-504: #eebe1b;
  --color-503: #ffffef;
  --color-502: #fde37d;
  --color-501: #daf200;
  --color-500: #f8e700;
  --color-424: rgba(80, 176, 18, 0.03);
  --color-423: rgba(80, 176, 18, 0.5);
  --color-422: #0f6a37;
  --color-421: #289e3f;
  --color-420: #54e0b5;
  --color-419: #11b886;
  --color-418: #22b573;
  --color-417: #0aa476;
  --color-416: #74b816;
  --color-415: #94d82d;
  --color-414: #c0eb75;
  --color-413: #b6d56b;
  --color-412: #d6ff32;
  --color-411: #eeffe3;
  --color-410: #31d9c8;
  --color-409: #90e71b;
  --color-408: #72ea24;
  --color-407: #9af144;
  --color-406: #76ffe5;
  --color-405: #c1f89d;
  --color-404: #d2fab8;
  --color-402: #bbd86c;
  --color-401: #50b012;
  --color-400: #2a894f;
  --color-309: #df4d18;
  --color-308: #c92a2a;
  --color-307: #ffc5d2;
  --color-306: #b10d0d;
  --color-305: #fa516f;
  --color-304: #bd142a;
  --color-303: #c3072a;
  --color-302: #930d24;
  --color-301: #ff0035;
  --color-300: #bf0f24;
  --color-228: #7ed9ff;
  --color-227: #54a9fe;
  --color-226: #1976d2;
  --color-225: #26b2f1;
  --color-224: #10a9ed;
  --color-223: #1265c2;
  --color-222: #35f0f4;
  --color-221: #e6f2ff;
  --color-220: #a9d4fe;
  --color-219: #b0e1f7;
  --color-218: #8cd3fa;
  --color-217: #11a9ed;
  --color-216: #216cc0;
  --color-215: #e1f4fc;
  --color-214: #00a2ea;
  --color-213: #13b2ea;
  --color-212: #0d82b5;
  --color-211: #3ff1ff;
  --color-210: rgba(171, 229, 252, 0.8);
  --color-209: #3397ed;
  --color-208: #c8ebfa;
  --color-207: #10a8ec;
  --color-206: #16b7ef;
  --color-205: #0d87bd;
  --color-204: #8fd6f7;
  --color-203: #abe5fc;
  --color-202: #73d4ff;
  --color-201: #11a9ed;
  --color-200: #0c7cad;
  --color-148: #595959;
  --color-147: #222222;
  --color-146: #6c6c6c;
  --color-145: #f4f4f4;
  --color-144: #515151;
  --color-143: #6c6c6c;
  --color-142: #d8d8d8;
  --color-141: rgba(250, 250, 250, 0.9);
  --color-140: #e6e6e6;
  --color-139: #4a4a4a;
  --color-138: #e0e0e0;
  --color-137: rgba(0, 0, 0, 0.1);
  --color-136: #d3d3d3;
  --color-135: rgba(110, 133, 148, 0.8);
  --color-134: #6e8594;
  --color-133: rgba(255, 255, 255, 0.25);
  --color-132: #aaaaaa;
  --color-131: #000000;
  --color-130: #e8e8e8;
  --color-129: rgba(163, 212, 250, 0.8);
  --color-128: #282828;
  --color-127: #dadada;
  --color-126: #e7e7e7;
  --color-125: rgba(0, 0, 0, 0.1);
  --color-124: #f2f2f2;
  --color-123: rgba(255, 255, 255, 0.85);
  --color-122: #c0c0c0;
  --color-121: #0e334c;
  --color-120: #444444;
  --color-119: #bbbbbb;
  --color-118: #eeeeee;
  --color-117: #212121;
  --color-116: #eaeaea;
  --color-115: #f2f2f2;
  --color-114: #999999;
  --color-113: #777777;
  --color-112: #333333;
  --color-111: #a4a4a4;
  --color-110: #ededed;
  --color-109: #e5e5e5;
  --color-108: #cccccc;
  --color-107: #dddddd;
  --color-106: #ffffff;
  --color-105: #f9f9f9;
  --color-104: #fafafa;
  --color-103: #c7c7c7;
  --color-102: #888888;
  --color-101: #555555;
  --color-100: #222222;
  --color-icon-secondary-hover: var(--color-black);
  --color-icon-secondary-dark: var(--color-darkui-surface-3);
  --color-icon-secondary: var(--color-darkui-accent-2);
  --color-icon-primary-hover: var(--color-blue-dark-1);
  --color-icon-primary: var(--color-blue-primary);
  --color-text-dark: var(--color-black);
  --color-text-medium: var(--color-darkui-accent-2);
  --color-text-light: var(--color-white);
  --color-secondary: var(--color-darkui-accent-2);
  --color-primary: var(--color-blue-primary);
  --color-highlight: #B4D8FD;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/styles/default-theme.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;EACtB,gDAAgD,EAAE,6BAA6B;EAC/E,gDAAgD,EAAE,6BAA6B;EAC/E,2CAA2C,EAAE,6BAA6B;EAC1E,2CAA2C,EAAE,6BAA6B;EAC1E,sDAAsD,EAAE,6BAA6B;EACrF,oCAAoC,EAAE,6BAA6B;EACnE,oCAAoC,EAAE,6BAA6B;EACnE,oDAAoD,EAAE,6BAA6B;EACnF,oDAAoD,EAAE,6BAA6B;EACnF,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oCAAoC;EACpC,mCAAmC;EACnC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qCAAqC;EACrC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qCAAqC;EACrC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,+BAA+B;EAC/B,oBAAoB;EACpB,qCAAqC;EACrC,oBAAoB;EACpB,sCAAsC;EACtC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qCAAqC;EACrC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,+BAA+B;EAC/B,oBAAoB;EACpB,sCAAsC;EACtC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,gDAAgD;EAChD,0DAA0D;EAC1D,oDAAoD;EACpD,oDAAoD;EACpD,+CAA+C;EAC/C,qCAAqC;EACrC,iDAAiD;EACjD,sCAAsC;EACtC,+CAA+C;EAC/C,0CAA0C;EAC1C,0BAA0B;AAC5B","sourcesContent":["/**\n * Do not edit directly\n * Generated on Tue, 19 Dec 2023 15:27:21 GMT\n */\n\n:root {\n  --spacing-xl: 55px;\n  --spacing-lg: 44px;\n  --spacing-md: 33px;\n  --spacing-sm: 22px;\n  --spacing-xs: 11px;\n  --color-purple-light-1: #aa8dfc;\n  --color-purple-light-2: #9370f9;\n  --color-purple-light-3: #815af7;\n  --color-purple-primary: #6f42f3;\n  --color-purple-dark-1: #6439e4;\n  --color-purple-dark-2: #5a30d7;\n  --color-purple-dark-3: #4f28c0;\n  --color-violet-light-1: #ed79d5;\n  --color-violet-light-2: #e55ecb;\n  --color-violet-light-3: #de45c6;\n  --color-violet-primary: #d42fc2;\n  --color-violet-dark-1: #cc1dc1;\n  --color-violet-dark-2: #c00fc4;\n  --color-violet-dark-3: #ac06bc;\n  --color-yellow-light-1: #ffe18e;\n  --color-yellow-light-2: #fedb7c;\n  --color-yellow-light-3: #fdd66b;\n  --color-yellow-primary: #faca48;\n  --color-yellow-dark-1: #f5bf2a;\n  --color-yellow-dark-2: #edb312;\n  --color-yellow-dark-3: #e4a700;\n  --color-orange-light-1: #ffb154;\n  --color-orange-light-2: #fd9d39;\n  --color-orange-light-3: #f98925;\n  --color-orange-primary: #f27716;\n  --color-orange-dark-1: #ea670e;\n  --color-orange-dark-2: #de5809;\n  --color-orange-dark-3: #cf4a06;\n  --color-teal-light-1: #66d9e8;\n  --color-teal-light-2: #3bc9db;\n  --color-teal-light-3: #22b8cf;\n  --color-teal-primary: #15aabf;\n  --color-teal-dark-1: #1098ad;\n  --color-teal-dark-2: #0c8599;\n  --color-teal-dark-3: #0b7285;\n  --color-lime-light-1: #e9fac8;\n  --color-lime-light-2: #d8f5a2;\n  --color-lime-light-3: #c0eb75;\n  --color-lime-primary: #a9e34b;\n  --color-lime-dark-1: #94d82d;\n  --color-lime-dark-2: #82c91e;\n  --color-lime-dark-3: #74b816;\n  --color-green-light-1: #60d275;\n  --color-green-light-2: #40c35d;\n  --color-green-light-3: #28b44e;\n  --color-green-primary: #16a544;\n  --color-green-dark-1: #0b963f;\n  --color-green-dark-2: #04873b;\n  --color-green-dark-3: #007838;\n  --color-red-light-1: #ff6f6f;\n  --color-red-light-2: #f85454;\n  --color-red-light-3: #ee3e3e;\n  --color-red-primary: #e02c2c;\n  --color-red-dark-1: #d32020;\n  --color-red-dark-2: #c21515;\n  --color-red-dark-3: #b10d0d;\n  --color-blue-light-1: #54a9fe;\n  --color-blue-light-2: #3b97f3;\n  --color-blue-light-3: #2a88e6;\n  --color-blue-primary: #1976d2;\n  --color-blue-dark-0: #000000;\n  --color-blue-dark-1: #1265c2;\n  --color-blue-dark-2: #0a59b2;\n  --color-blue-dark-3: #004ba0;\n  --color-white: #ffffff;\n  --color-lightui-surface-1: #fbfbfb;\n  --color-lightui-surface-2: #f4f4f4;\n  --color-lightui-surface-3: #efefef;\n  --color-lightui-surface-4: #e4e4e4;\n  --color-lightui-accent-1: #d8d8d8;\n  --color-lightui-accent-2: #c3c3c3;\n  --color-darkui-accent-3: #a6a6a6;\n  --color-darkui-accent-2: #6c6c6c;\n  --color-darkui-accent-1: #515151;\n  --color-darkui-surface-4: #3b3b3b;\n  --color-darkui-surface-3: #252525;\n  --color-darkui-surface-2: #1d1d1d;\n  --color-darkui-surface-1: #101010;\n  --color-black: #000000;\n  --color-blue-light-1-30: rgba(84, 169, 254, 0.3); /* #54a9fe with 30% opacity */\n  --color-blue-light-1-50: rgba(84, 169, 254, 0.5); /* #54a9fe with 50% opacity */\n  --color-white-85: rgba(255, 255, 255, 0.85); /* #ffffff with 85% opacity */\n  --color-white-25: rgba(255, 255, 255, 0.25); /* #ffffff with 25% opacity */\n  --color-lightui-surface-1-90: rgba(251, 251, 251, 0.9); /* #fbfbfb with 90% opacity */\n  --color-black-50: rgba(0, 0, 0, 0.5); /* #000000 with 50% opacity */\n  --color-black-10: rgba(0, 0, 0, 0.1); /* #000000 with 10% opacity */\n  --color-darkui-accent-2-50: rgba(108, 108, 108, 0.5); /* #6c6c6c with 50% opacity */\n  --color-darkui-accent-2-80: rgba(108, 108, 108, 0.8); /* #6c6c6c with 80% opacity */\n  --color-712: #ff5d7c;\n  --color-711: #d527c0;\n  --color-710: #ddc909;\n  --color-709: #6f42f3;\n  --color-708: #815af7;\n  --color-707: #a606bc;\n  --color-706: #df88cd;\n  --color-705: #cf18c4;\n  --color-704: #de33cb;\n  --color-703: #9c00ff;\n  --color-702: #6439e4;\n  --color-701: #cf23b8;\n  --color-700: #632d5c;\n  --color-617: #ff9735;\n  --color-616: #f27019;\n  --color-615: #feaf5a;\n  --color-614: #ff841e;\n  --color-613: #fed7a5;\n  --color-612: #ed7e00;\n  --color-611: #ff9e0d;\n  --color-610: #ffbc50;\n  --color-609: #ffbc50;\n  --color-608: #ff9406;\n  --color-607: #ffa910;\n  --color-606: #ffdd9e;\n  --color-605: #ed7e00;\n  --color-604: #e9ae00;\n  --color-602: #cc6300;\n  --color-601: #ff9e0d;\n  --color-600: #fc9e31;\n  --color-504: #eebe1b;\n  --color-503: #ffffef;\n  --color-502: #fde37d;\n  --color-501: #daf200;\n  --color-500: #f8e700;\n  --color-424: rgba(80, 176, 18, 0.03);\n  --color-423: rgba(80, 176, 18, 0.5);\n  --color-422: #0f6a37;\n  --color-421: #289e3f;\n  --color-420: #54e0b5;\n  --color-419: #11b886;\n  --color-418: #22b573;\n  --color-417: #0aa476;\n  --color-416: #74b816;\n  --color-415: #94d82d;\n  --color-414: #c0eb75;\n  --color-413: #b6d56b;\n  --color-412: #d6ff32;\n  --color-411: #eeffe3;\n  --color-410: #31d9c8;\n  --color-409: #90e71b;\n  --color-408: #72ea24;\n  --color-407: #9af144;\n  --color-406: #76ffe5;\n  --color-405: #c1f89d;\n  --color-404: #d2fab8;\n  --color-402: #bbd86c;\n  --color-401: #50b012;\n  --color-400: #2a894f;\n  --color-309: #df4d18;\n  --color-308: #c92a2a;\n  --color-307: #ffc5d2;\n  --color-306: #b10d0d;\n  --color-305: #fa516f;\n  --color-304: #bd142a;\n  --color-303: #c3072a;\n  --color-302: #930d24;\n  --color-301: #ff0035;\n  --color-300: #bf0f24;\n  --color-228: #7ed9ff;\n  --color-227: #54a9fe;\n  --color-226: #1976d2;\n  --color-225: #26b2f1;\n  --color-224: #10a9ed;\n  --color-223: #1265c2;\n  --color-222: #35f0f4;\n  --color-221: #e6f2ff;\n  --color-220: #a9d4fe;\n  --color-219: #b0e1f7;\n  --color-218: #8cd3fa;\n  --color-217: #11a9ed;\n  --color-216: #216cc0;\n  --color-215: #e1f4fc;\n  --color-214: #00a2ea;\n  --color-213: #13b2ea;\n  --color-212: #0d82b5;\n  --color-211: #3ff1ff;\n  --color-210: rgba(171, 229, 252, 0.8);\n  --color-209: #3397ed;\n  --color-208: #c8ebfa;\n  --color-207: #10a8ec;\n  --color-206: #16b7ef;\n  --color-205: #0d87bd;\n  --color-204: #8fd6f7;\n  --color-203: #abe5fc;\n  --color-202: #73d4ff;\n  --color-201: #11a9ed;\n  --color-200: #0c7cad;\n  --color-148: #595959;\n  --color-147: #222222;\n  --color-146: #6c6c6c;\n  --color-145: #f4f4f4;\n  --color-144: #515151;\n  --color-143: #6c6c6c;\n  --color-142: #d8d8d8;\n  --color-141: rgba(250, 250, 250, 0.9);\n  --color-140: #e6e6e6;\n  --color-139: #4a4a4a;\n  --color-138: #e0e0e0;\n  --color-137: rgba(0, 0, 0, 0.1);\n  --color-136: #d3d3d3;\n  --color-135: rgba(110, 133, 148, 0.8);\n  --color-134: #6e8594;\n  --color-133: rgba(255, 255, 255, 0.25);\n  --color-132: #aaaaaa;\n  --color-131: #000000;\n  --color-130: #e8e8e8;\n  --color-129: rgba(163, 212, 250, 0.8);\n  --color-128: #282828;\n  --color-127: #dadada;\n  --color-126: #e7e7e7;\n  --color-125: rgba(0, 0, 0, 0.1);\n  --color-124: #f2f2f2;\n  --color-123: rgba(255, 255, 255, 0.85);\n  --color-122: #c0c0c0;\n  --color-121: #0e334c;\n  --color-120: #444444;\n  --color-119: #bbbbbb;\n  --color-118: #eeeeee;\n  --color-117: #212121;\n  --color-116: #eaeaea;\n  --color-115: #f2f2f2;\n  --color-114: #999999;\n  --color-113: #777777;\n  --color-112: #333333;\n  --color-111: #a4a4a4;\n  --color-110: #ededed;\n  --color-109: #e5e5e5;\n  --color-108: #cccccc;\n  --color-107: #dddddd;\n  --color-106: #ffffff;\n  --color-105: #f9f9f9;\n  --color-104: #fafafa;\n  --color-103: #c7c7c7;\n  --color-102: #888888;\n  --color-101: #555555;\n  --color-100: #222222;\n  --color-icon-secondary-hover: var(--color-black);\n  --color-icon-secondary-dark: var(--color-darkui-surface-3);\n  --color-icon-secondary: var(--color-darkui-accent-2);\n  --color-icon-primary-hover: var(--color-blue-dark-1);\n  --color-icon-primary: var(--color-blue-primary);\n  --color-text-dark: var(--color-black);\n  --color-text-medium: var(--color-darkui-accent-2);\n  --color-text-light: var(--color-white);\n  --color-secondary: var(--color-darkui-accent-2);\n  --color-primary: var(--color-blue-primary);\n  --color-highlight: #B4D8FD;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
